import { useStatsigClient } from '@statsig/react-bindings';
import { useCallback } from 'react';

export enum AnalyticsEvent {
  // Auth
  AUTH_LOGIN = 'auth_login',
  AUTH_LOGOUT = 'auth_logout',
  // Integration
  INTEGRATION_VALIDATE_SUCCESS = 'integration_validate_success',
  INTEGRATION_VALIDATE_FAILURE = 'integration_validate_failure',
  INTEGRATION_CONNECTED = 'integration_connected',
  INTEGRATION_DISCONNECT = 'integration_disconnect',
}

export function useAnalytics() {
  const { client } = useStatsigClient();

  const track = useCallback(
    (event: AnalyticsEvent, metadata?: Record<string, string>) => {
      client.logEvent(event, undefined, metadata);
    },
    [client]
  );

  return { track };
}
